import { render } from "./MainSearchBar.vue?vue&type=template&id=4648e1d6&scoped=true"
import script from "./MainSearchBar.vue?vue&type=script&lang=js"
export * from "./MainSearchBar.vue?vue&type=script&lang=js"

import "./MainSearchBar.vue?vue&type=style&index=0&id=4648e1d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4648e1d6"]])

export default __exports__